// ---------- START IMPORT BLOCK ----------
import APIService from '../Core/APIService';
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
import type { SpecialtyRead, SubspecialtyRead } from '../../Types/schema-helpers';

// ---------- END IMPORT BLOCK ----------

export default class SpecialtiesService extends APIService {
  // ==========================================
  // SPECIALTIES
  // ==========================================

  /**
   * Searches specialties by query string.
   */
  async searchSpecialties(
    query: string,
    signal?: AbortSignal
  ): Promise<SpecialtyRead[]> {
    const route = API_ROUTES.search_specialties(query);
    const config = signal ? { signal } : undefined;
    return this.get<SpecialtyRead[]>(route, config);
  }

  /**
   * Fetches a single specialty document by its ID.
   
  async getSpecialtyById(
    specialtyId: string,
    signal?: AbortSignal
  ): Promise<SpecialtyRead> {
    const route = API_ROUTES.get_specialty_by_id(specialtyId);
    const config = signal ? { signal } : undefined;
    return this.get<SpecialtyRead>(route, config);
  }
    */

  // ==========================================
  // SUBSPECIALTIES
  // ==========================================

  /**
   * Searches subspecialties by query string, with optional filtering by parent specialtyId.
   */
  async searchSubspecialties(
    query: string,
    specialtyId?: string | null,
    signal?: AbortSignal
  ): Promise<SubspecialtyRead[]> {
    const route = API_ROUTES.search_subspecialties(query, specialtyId ?? undefined);
    const config = signal ? { signal } : undefined;
    return this.get<SubspecialtyRead[]>(route, config);
  }

  /**
   * Fetches a single subspecialty document by its ID.
   
  async getSubspecialtyById(
    subspecialtyId: string,
    signal?: AbortSignal
  ): Promise<SubspecialtyRead> {
    const route = API_ROUTES.get_subspecialty_by_id(subspecialtyId);
    const config = signal ? { signal } : undefined;
    return this.get<SubspecialtyRead>(route, config);
  }
    */
}
